import { render, staticRenderFns } from "./DSList.vue?vue&type=template&id=5ab39854&"
import script from "./DSList.vue?vue&type=script&lang=js&"
export * from "./DSList.vue?vue&type=script&lang=js&"
import style0 from "./DSList.vue?vue&type=style&index=0&id=5ab39854&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports